import React from 'react';

// Renders the user's self-contained Talesverse Memories Market HTML exactly as-is.
// The source file lives at /public/memories.html and is served statically.
export default function MemoriesMarketPage() {
  return (
    <iframe
      src="/memories.html"
      title="Talesverse Memories Market"
      data-testid="memories-market-frame"
      style={{ position: 'fixed', inset: 0, width: '100%', height: '100%', border: 'none', display: 'block' }}
    />
  );
}
